import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind class merge helper. Matches shadcn convention.
 *
 * Ported from black-mirror src/lib/utils.ts (lines 1-11). The rest of
 * black-mirror's utils.ts is domain-specific (peopleSelectorColumns, currency
 * formatters, bucketing helpers) which we don't need for Sales Coach.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
